// import { useEffect, useState } from 'react';
import { InformationPopoverContentUI } from './InformationPopoverContentUI';
// import { useStrategy } from '../../hooks/useStrategy';
// import { FilterField } from '../../types/FilterField';
import { jsx as _jsx } from "react/jsx-runtime";
export const InformationPopoverContent = ({
  __filterFamily,
  name
}) => {
  // TODO: Use or remove in next iteration
  // const { getField } = useStrategy();
  // const [__info, setInfo] = useState<FilterField | undefined>();

  // useEffect(() => {
  //   const loadInfo = async () => {
  //     try {
  //       const field = await getField(filterFamily, name);
  //       setInfo(field);
  //     } catch (error) {
  //       console.error('Error loading info:', error);
  //     }
  //   };

  //   void loadInfo();
  // }, [filterFamily, getField, name]);

  return /*#__PURE__*/_jsx(InformationPopoverContentUI, {
    label: name
  });
};